import * as React from 'react';
import SVGUniqueID from 'react-svg-unique-id';

interface CheckCircleIconProps {
  width?: number;
  height?: number;
}

const CheckCircleIcon: React.FC<CheckCircleIconProps> = ({
  width = 32,
  height = 32
}) => (
  <SVGUniqueID>
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width={width} height={height} rx={width / 2} fill="#16A34A" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.9997 7.19998C11.1396 7.19998 7.19971 11.1399 7.19971 16C7.19971 20.8601 11.1396 24.8 15.9997 24.8C20.8598 24.8 24.7997 20.8601 24.7997 16C24.7997 11.1399 20.8598 7.19998 15.9997 7.19998ZM20.1654 14.1657C20.4778 13.8532 20.4778 13.3467 20.1654 13.0343C19.853 12.7219 19.3464 12.7219 19.034 13.0343L14.7997 17.2686L12.9654 15.4343C12.653 15.1219 12.1464 15.1219 11.834 15.4343C11.5216 15.7467 11.5216 16.2532 11.834 16.5657L14.234 18.9657C14.5464 19.2781 15.053 19.2781 15.3654 18.9657L20.1654 14.1657Z"
        fill="white"
      />
    </svg>
  </SVGUniqueID>
);
export { CheckCircleIcon };
